const { default: parentApi } = require("store/parentApi");

// Analytics endpoints
//
// Overview:  POST /analytics/v1/:attribute
//   Body:     { userId, startDate?, endDate? }
//   Response: { data: { kpis, items, trendOverTime } }
//
// Detail:    POST /analytics/v1/:attribute/:item
//   Body:     { userId, startDate?, endDate? }
//   Response: { data: { kpis, quizHistory, trendOverTime } }
const analyticsApis = parentApi.injectEndpoints({
  endpoints: (build) => ({
    getAnalyticsPerformance: build.query({
      query: (body) => ({
        url: `analytics/v1/${body.attribute}`,
        method: "POST",
        body: {
          userId: body.userId,
          ...(body.startDate && { startDate: body.startDate }),
          ...(body.endDate && { endDate: body.endDate }),
        },
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["analyticsPerformance"],
    }),

    getAnalyticsDetail: build.query({
      query: (body) => ({
        url: `analytics/v1/${body.attribute}/${encodeURIComponent(body.item)}`,
        method: "POST",
        body: {
          userId: body.userId,
          ...(body.startDate && { startDate: body.startDate }),
          ...(body.endDate && { endDate: body.endDate }),
        },
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["analyticsDetail"],
    }),
  }),
});

export const {
  useGetAnalyticsPerformanceQuery,
  useLazyGetAnalyticsPerformanceQuery,
  useGetAnalyticsDetailQuery,
  useLazyGetAnalyticsDetailQuery,
} = analyticsApis;
